import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import PassengerService from "../../../../services/reservations/PassengerService";

export const REQUEST_FETCH_PASSENGERS_INGALA =
  "REQUEST_FETCH_PASSENGERS_INGALA";
export const FETCH_PASSENGERS_INGALA_SUCCESS =
  "FETCH_PASSENGERS_INGALA_SUCCESS";
export const FETCH_PASSENGERS_INGALA_ERROR = "FETCH_PASSENGERS_INGALA_ERROR";
export const INITIAL_STATE_PASSENGER_INGALA = "INITIAL_STATE_PASSENGER_INGALA";

function requestFetchPassengersIngala() {
  return {
    type: REQUEST_FETCH_PASSENGERS_INGALA,
  };
}

function fetchPassengersIngalaSuccess(json) {
  return {
    type: FETCH_PASSENGERS_INGALA_SUCCESS,
    passengers: json.data,
  };
}

function fetchPassengersIngalaError(json) {
  return {
    type: FETCH_PASSENGERS_INGALA_ERROR,
    error: json.data,
  };
}

export function initialStatePassengerIngala() {
  return {
    type: INITIAL_STATE_PASSENGER_INGALA,
  };
}

export function fetchPassengersIngala(cruise_id) {
  return (dispatch) => {
    dispatch(requestFetchPassengersIngala());
    return PassengerService.getPassengersIngala(cruise_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchPassengersIngalaSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchPassengersIngala(cruise_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchPassengersIngalaError(json.data));
      }
    });
  };
}
